import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

export const SATISFACTION_FORM_ANSWERS_SERVICE = {
    getSatisfactionFormAnswers, getSatisfactionFormAnswerById
};

const API_ROOT_SERVICE = "SatisfactionForms";

function getSatisfactionFormAnswers(queryParams) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "answers"]);
    const requestOptions = { method: 'GET', headers: { ...authHeader() } };
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function getSatisfactionFormAnswerById(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "answers", id]);
    const requestOptions = { method: 'GET', headers: { ...authHeader() } };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

